import { render } from "./Outer.vue?vue&type=template&id=4f13bf6a&scoped=true"
import script from "./Outer.vue?vue&type=script&lang=js"
export * from "./Outer.vue?vue&type=script&lang=js"

import "./Outer.vue?vue&type=style&index=0&id=4f13bf6a&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f13bf6a"]])

export default __exports__